module.exports = __webpack_public_path__ + "img/area-icon.1614b7a3.png";